import axios from 'axios';
import { createFolderQuery } from './queries';
import Split from '../split';
import { buildExpressQuery, buildLoopbackQuery } from './queries/builders';

const addFolder = (model) =>
    new Promise((resolve, reject) => {
        const useExpressMigration = Split.getBooleanTreatment('use_express_migration_endpoints');
        const queryBuilder = useExpressMigration ? buildExpressQuery : buildLoopbackQuery;
        const query = createFolderQuery({ model, queryBuilder });
        const request = axios.post(query.url, { ...query.body });
        request
            .then((response) => {
                resolve({ data: response.data });
            })
            .catch((errors) => {
                // eslint-disable-next-line no-console
                console.log(errors);
                reject(new Error('Unable to add folder'));
            });
    });

export default addFolder;
